<template>
  <div class="icon-title">
    <div class="title">
      <div class="icon">
          <i class="iconfont" :class="icon"></i>
      </div>
      <span>{{ title }}</span>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
    props: ['title', 'icon']
}
</script>

<style lang="scss" scoped>
.icon-title{
  line-height: 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  >.title{
    display: flex;
    align-items: center;
    >.icon{
      width: 28px;
      height: 28px;
      background: #44C9C1;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;
      >.iconfont{
        color: #fff;
        font-size: 14px;
      }
    }
    > span{
      color: #2E2F33;
      font-weight: bold;
      font-size: 22px;
      margin-left: 8px;
    }
  }
}
</style>>



// WEBPACK FOOTER //
// src/components/common/iconTitle.vue